<template>

  <div class="comments" >
    <van-row class="my_returns_detailed my_Recharge_type_top">
      <!-- 消费记录 -->
      <van-col span="22" offset="1">
        <van-tabs v-model="active" @click="onClicktype">
          <van-tab :title="$t('other.consume')">
            <van-col span="24" v-if="is_list">
              <van-list
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                :finished-text="$t('onLoad.finished_text')"
                @load="onLoad"
                :offset="10"
              >
                <van-cell v-for="t in list" :key="t.id">
                  <van-col span="24" class="my_returns_type">
                    <van-col span="18" class="my_consume_type_name">{{ t.content }}</van-col>
                    <van-col span="6">
                      <van-col span="24" class="my_consume_type_money"> - {{ t.coin }}</van-col>
                      <van-col span="24" class="my_consume_type_time">{{ t.create_time }}</van-col>
                    </van-col>
                  </van-col>
                </van-cell>
              </van-list>
            </van-col>
            <van-col span="24" v-else>
              <van-col span="24" class="no-data">
                <img src="../assets/img/zwsl.png"/>
              </van-col>
              <van-col span="24" class="no-data-name" >{{ $t('onLoad.No_record') }}</van-col>
            </van-col>
          </van-tab>
          <van-tab :title="$t('other.Recharge')">
            <van-col span="24" v-if="is_list">
              <van-list
                v-model="loading"
                :finished="finished"
                :immediate-check="false"
                :finished-text="$t('onLoad.finished_text')"
                @load="onLoad"
                :offset="10"
              >
                <van-cell v-for="t in list" :key="t.id">
                  <van-col span="24" class="my_returns_type" v-if="t.table_id">
                    <van-col span="18">
                      <van-col span="24" class="my_Recharge_type_name">{{ $t('other.Recharge')}}{{ t.status == 1 ? $t('other.success') : $t('other.fail') }}</van-col>
                      <van-col span="24" class="my_Recharge_name">{{ t.pay_name }} </van-col>
                    </van-col>
                    <van-col span="6">
                      <van-col span="24" class="my_consume_type_money my_Recharge_name_color"> {{ t.status == 1 ? '+' : '' }} {{ t.coin }} </van-col>
                      <van-col span="24" class="my_consume_type_time">{{ t.addtime }}</van-col>
                    </van-col>
                  </van-col>
                  <van-col span="24" class="my_returns_type" v-else>
                    <van-col span="18" class="my_consume_type_name">{{ t.content }}</van-col>
                    <van-col span="6">
                      <van-col span="24" class="my_consume_type_money"> + {{ t.send_coin }}</van-col>
                      <van-col span="24" class="my_consume_type_time">{{ t.create_time }}</van-col>
                    </van-col>
                  </van-col>
                </van-cell>
              </van-list>
            </van-col>
            <van-col span="24" v-else>
              <van-col span="24" class="no-data">
                <img src="../assets/img/zwsl.png"/>
              </van-col>
              <van-col span="24" class="no-data-name" >{{ $t('onLoad.No_record') }}</van-col>
            </van-col>
          </van-tab>
        </van-tabs>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast";
  export default {
    data() {
      return {
        date: '',
        finished: false,
        loading: false,
        active: 0,
        list: [],
        is_list: false,
        page: 1
      }
    },
    created: function() {
      this.page = 1
      this.list = []
      this.select_list()
      document.title = this.$t('title.Consumption_details')
    },
    methods: {
      onClicktype (name, title) {
        this.list = []
        this.page = 1
        this.active = name
        this.select_list()
      },
      onLoad() {
        this.select_list()
      },
      select_list() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token

        const url = this.active !== 1 ?  "mapi/public/index.php/api/userinfo_api/consumption_log" : "mapi/public/index.php/api/userinfo_api/vue_recharge_page"
        axios.get(this.baseUrlApi + url, {
          params: {
            uid: uid,
            token: token,
            p: this.page
          }
        }).then(res => {
          if (res.data.code == 1) {
            if (res.data.list.length > 0) {
              for (let i = 0; i < res.data.list.length; i++) {
                this.list.push(res.data.list[i])
              }
              this.is_list = true
              this.loading = false
              this.page = this.page + 1
            } else {
              if(this.page == 1) {
                this.is_list = false
              }
              this.finished = true
              this.loading = true
            }
          } else {
            if(this.page == 1) {
              this.is_list = false
            }
            this.loading = true
            if(this.page !== 1) {
              Toast(this.$t('onLoad.No_data_available'))
            }
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/consumption_log.vue